var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 50,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.1259 31.4985C77.8726 33.0264 77.6908 34.5625 77.3558 36.0782C74.6778 48.1016 64.3458 57.3387 52.0589 58.7338C37.2902 60.4129 23.7879 51.2228 19.9476 36.8769C16.3423 23.3849 23.171 8.78362 35.8623 2.87C39.064 1.34961 42.5134 0.418251 46.0452 0.120519C46.1926 0.0951858 46.3371 0.0548014 46.4762 0L50.6045 0C51.6055 0.149117 52.6084 0.27985 53.6073 0.447352C65.2282 2.38588 74.8065 11.4187 77.3558 22.8783C77.6969 24.4083 77.8746 25.973 78.1259 27.5213V31.4985ZM46.3292 14.685V31.7416H63.4V27.1679H50.864V14.685H46.3292Z",
    fill: "#549A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.703 58.5868L8.71866 72.6692L5.55859 69.4989L19.5082 55.4042L22.703 58.5868Z",
    fill: "#549A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7036 60.6848L34.8065 63.7325L22.732 75.9192L19.623 72.8286L31.7036 60.6848Z",
    fill: "#549A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.27694 58.542L2.21289 55.5167C6.23565 51.4613 10.2679 47.3997 14.3098 43.332L17.3738 46.3736L5.27694 58.542Z",
    fill: "#549A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.1621 43.4238L0 40.2801L11.004 29.2107C12.0683 30.2688 13.1407 31.331 14.1457 32.3278L3.1621 43.4238Z",
    fill: "#549A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9591 78.1579L34.7949 75.0408L45.848 63.9366L48.9652 67.0436L37.9591 78.1579Z",
    fill: "#549A9A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_240"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78.1252,
    height: 78.1579,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clockIcon.1b4260549de0f85b51f5e5783adb4ec8.svg";
export { ForwardRef as ReactComponent };